import { NOOUI_SET_CURRENT_THEME } from 'shared/constants/actionTypes';

export const setCurrentTheme = themeName => ({
  type: NOOUI_SET_CURRENT_THEME,
  payload: themeName
});
